import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
    eur: [],
    chf: [],
    isGetEurLoading: false,
    isGetChfLoading: false,
    setTTFPriceProfile: [],
    isGetSetPriceProfileLoading: false,
    isCreatePriceProfileLoading: false,
    isBuySetPriceProfileLoading: false,
    isDeletePriceProfileLoading: false,
    minMaxDisplayEur: [],
    minMaxDisplayChf: [],
    isGetMinMaxDisplayLoading: false,
    trailingStopForDisplayEur: [],
    trailingStopForDisplayChf: [],
    isGetTrailingStopLoading: false,
    minMaxOrders: [],
    disableTrading: {},
    isGetMinMaxOrdersLoading: false,
    isBuyLoading: false,
    isSavetoWatchlistLoading: false,
    isSaveTrailingStop: false,
    isSetDisableTradingLoading: false,
    isGetDisableTradingLoading: false,
    ncgDataPoints: [],
    isGetNcgDataPointsLoading: false,
    analysisSignal: [],
    isGetAnalysisSignalLoading: false
};
export const apiGetTtfEur = createAsyncThunk(
    'ttf/getEur',
    async (_, thunkAPI) => {
        try {
            const response = await axios.get('/api/set/getttfdata');
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetTtfChf = createAsyncThunk(
    'ttf/getChf',
    async (_, thunkAPI) => {
        try {
            const response = await axios.get('/api/set/getttfdata/chf');
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetTtfSetPriceProfile = createAsyncThunk(
    'ttf/getSetPriceProfile',
    async (product = 'TTF', thunkAPI) => {
        try {
            const response = await axios.get(
                `/api/set/getpriceprofile?product=${product}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiSaveTtfPriceProfile = createAsyncThunk(
    'ttf/savePriceProfile',
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(
                `/api/set/savepriceprofile`,
                data
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiBuyTtfSetPriceProfile = createAsyncThunk(
    'ttf/buySetPriceProfile',
    async ({ data }, thunkAPI) => {
        try {
            const response = await axios.post(`/api/set/buypriceprofile`, data);
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiDeleteTtfProfile = createAsyncThunk(
    'ttf/deletePriceProfile',
    async ({ data }, thunkAPI) => {
        try {
            const response = await axios.post(
                `/api/set/deletepriceprofile`,
                data
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetTtfMinMaxDisplay = createAsyncThunk(
    'ttf/getMinMaxDisplay',
    async ({ product, currency }, thunkAPI) => {
        try {
            const response = await axios.get(
                `/api/set/getMinMaxForDisplay?product=${product}&currency=${currency}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetTtfTrailingStopForDisplay = createAsyncThunk(
    'ttf/getTrailingStop',
    async ({ product, currency }, thunkAPI) => {
        try {
            const response = await axios.get(
                `/api/set/getTrailingStopForDisplay?product=${product}&currency=${currency}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetTtfMinMaxOrders = createAsyncThunk(
    'ttf/getMinMaxOrders',
    async (_, thunkAPI) => {
        try {
            const response = await axios.get(`/api/set/getMinMaxOrders`);
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiBuyTtfContract = createAsyncThunk(
    'ttf/buyTtfContract',
    async (data, thunkAPI) => {
        try {
            const response = await axios.post('/api/saveorder', data);
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiBuyTtfContractMinMax = createAsyncThunk(
    'ttf/buyTtfContractMinMax',
    async (data, thunkAPI) => {
        try {
            const response = await axios.post('/api/saveMinMaxOrder', data);
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiSaveTtfTrailingStop = createAsyncThunk(
    'ttf/saveTrailingStop',
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(
                '/api/set/saveTrailingStop',
                data
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

// set disable trading
export const apiSetTtfDisableTrading = createAsyncThunk(
    'ttf/setDisableTrading',
    async (disableTrading, thunkAPI) => {
        try {
            const response = await axios.post(
                `/api/disable_trading?disable=${disableTrading.disable}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

// save to watchlist
export const apiSaveToWatchlistTtf = createAsyncThunk(
    'ttf/saveToWatchlist',
    async ({ symbol, product, currency }, thunkAPI) => {
        try {
            const response = await axios.post(
                `/api/save_to_watchlist?symbol=${symbol}&product=${product}&currency=${
                    currency || ''
                }`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

// get disable trading
export const apiGetTtfDisableTrading = createAsyncThunk(
    'ttf/getDisableTrading',
    async (_, thunkAPI) => {
        try {
            const response = await axios.get(`/api/disable_trading`);
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetTtfNcgDataPoints = createAsyncThunk(
    'ttf/getNcgDataPoints',
    async ({ sym, currency }, thunkAPI) => {
        try {
            const response = await axios.get(
                `/api/get_ncg_data_points?sym=${sym}&currency=${currency}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const apiGetTtfAnalysisSignal = createAsyncThunk(
    'ttf/getAnalysisSignal',
    async ({ sym, product }, thunkAPI) => {
        try {
            const response = await axios.get(
                `/api/get_analysis_signals?symbol=${sym}&product=${product}`
            );
            return {
                data: response.data,
                status: response.status,
                statusText: response.message
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const ttfSlice = createSlice({
    name: 'ttf',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get TTF EUR
        builder
            .addCase(apiGetTtfEur.pending, (state) => {
                state.isGetEurLoading = true;
            })
            .addCase(apiGetTtfEur.fulfilled, (state, action) => {
                state.eur = action.payload.data;
                state.isGetEurLoading = false;
            })
            .addCase(apiGetTtfEur.rejected, (state) => {
                state.isGetEurLoading = false;
            });

        // Get TTF CHF
        builder
            .addCase(apiGetTtfChf.pending, (state) => {
                state.isGetChfLoading = true;
            })
            .addCase(apiGetTtfChf.fulfilled, (state, action) => {
                state.chf = action.payload.data;
                state.isGetChfLoading = false;
            })
            .addCase(apiGetTtfChf.rejected, (state) => {
                state.isGetChfLoading = false;
            });

        // Get Set Priceprofile
        builder
            .addCase(apiGetTtfSetPriceProfile.pending, (state) => {
                state.isGetSetPriceProfileLoading = true;
            })
            .addCase(apiGetTtfSetPriceProfile.fulfilled, (state, action) => {
                state.isGetSetPriceProfileLoading = false;
                state.setTTFPriceProfile = action.payload.data;
            })
            .addCase(apiGetTtfSetPriceProfile.rejected, (state) => {
                state.isGetSetPriceProfileLoading = false;
            });

        // Save Price Profile
        builder
            .addCase(apiSaveTtfPriceProfile.pending, (state) => {
                state.isCreatePriceProfileLoading = true;
            })
            .addCase(apiSaveTtfPriceProfile.fulfilled, (state) => {
                state.isCreatePriceProfileLoading = false;
            })
            .addCase(apiSaveTtfPriceProfile.rejected, (state) => {
                state.isCreatePriceProfileLoading = false;
            });

        // Buy Price Profile
        builder
            .addCase(apiBuyTtfSetPriceProfile.pending, (state) => {
                state.isBuySetPriceProfileLoading = true;
            })
            .addCase(apiBuyTtfSetPriceProfile.fulfilled, (state) => {
                state.isBuySetPriceProfileLoading = false;
            })
            .addCase(apiBuyTtfSetPriceProfile.rejected, (state) => {
                state.isBuySetPriceProfileLoading = false;
            });

        // Delete Price Profile
        builder
            .addCase(apiDeleteTtfProfile.pending, (state) => {
                state.isDeletePriceProfileLoading = true;
            })
            .addCase(apiDeleteTtfProfile.fulfilled, (state) => {
                state.isDeletePriceProfileLoading = false;
            })
            .addCase(apiDeleteTtfProfile.rejected, (state) => {
                state.isDeletePriceProfileLoading = false;
            });

        // Get Min Max Display
        builder
            .addCase(apiGetTtfMinMaxDisplay.pending, (state) => {
                state.isGetMinMaxDisplayLoading = true;
            })
            .addCase(apiGetTtfMinMaxDisplay.fulfilled, (state, action) => {
                state.isGetMinMaxDisplayLoading = false;
                const currency = action.meta.arg?.currency;
                if (currency === 'CHF') {
                    state.minMaxDisplayChf = action.payload.data;
                } else {
                    state.minMaxDisplayEur = action.payload.data;
                }
            })
            .addCase(apiGetTtfMinMaxDisplay.rejected, (state) => {
                state.isGetMinMaxDisplayLoading = false;
            });

        // Get Trailing Stop
        builder
            .addCase(apiGetTtfTrailingStopForDisplay.pending, (state) => {
                state.isGetTrailingStopLoading = true;
            })
            .addCase(
                apiGetTtfTrailingStopForDisplay.fulfilled,
                (state, action) => {
                    state.isGetTrailingStopLoading = false;
                    const currency = action.meta.arg?.currency;
                    if (currency === 'CHF') {
                        state.trailingStopForDisplayChf = action.payload.data;
                    } else {
                        state.trailingStopForDisplayEur = action.payload.data;
                    }
                }
            )
            .addCase(apiGetTtfTrailingStopForDisplay.rejected, (state) => {
                state.isGetTrailingStopLoading = false;
            });

        // Get Min Max Orders
        builder
            .addCase(apiGetTtfMinMaxOrders.pending, (state) => {
                state.isGetMinMaxOrdersLoading = true;
            })
            .addCase(apiGetTtfMinMaxOrders.fulfilled, (state, action) => {
                state.isGetMinMaxOrdersLoading = false;
                state.minMaxOrders = action.payload.data;
            })
            .addCase(apiGetTtfMinMaxOrders.rejected, (state) => {
                state.isGetMinMaxOrdersLoading = false;
            });

        // Buy Contract
        builder
            .addCase(apiBuyTtfContract.pending, (state) => {
                state.isBuyLoading = true;
            })
            .addCase(apiBuyTtfContract.fulfilled, (state) => {
                state.isBuyLoading = false;
            })
            .addCase(apiBuyTtfContract.rejected, (state) => {
                state.isBuyLoading = false;
            });

        // Buy Contract Min Max
        builder
            .addCase(apiBuyTtfContractMinMax.pending, (state) => {
                state.isBuyLoading = true;
            })
            .addCase(apiBuyTtfContractMinMax.fulfilled, (state) => {
                state.isBuyLoading = false;
            })
            .addCase(apiBuyTtfContractMinMax.rejected, (state) => {
                state.isBuyLoading = false;
            });

        // save trailing stop
        builder
            .addCase(apiSaveTtfTrailingStop.pending, (state) => {
                state.isSaveTrailingStop = true;
            })
            .addCase(apiSaveTtfTrailingStop.fulfilled, (state) => {
                state.isSaveTrailingStop = false;
            })
            .addCase(apiSaveTtfTrailingStop.rejected, (state) => {
                state.isSaveTrailingStop = false;
            });

        // set disable trading
        builder
            .addCase(apiSetTtfDisableTrading.pending, (state) => {
                state.isSetDisableTradingLoading = true;
            })
            .addCase(apiSetTtfDisableTrading.fulfilled, (state) => {
                state.isSetDisableTradingLoading = false;
            })
            .addCase(apiSetTtfDisableTrading.rejected, (state) => {
                state.isSetDisableTradingLoading = false;
            });

        // Save to Watchlist
        builder
            .addCase(apiSaveToWatchlistTtf.pending, (state) => {
                state.isSavetoWatchlistLoading = true;
            })
            .addCase(apiSaveToWatchlistTtf.fulfilled, (state) => {
                state.isSavetoWatchlistLoading = false;
            })
            .addCase(apiSaveToWatchlistTtf.rejected, (state) => {
                state.isSavetoWatchlistLoading = false;
            });

        // get disable trading
        builder
            .addCase(apiGetTtfDisableTrading.pending, (state) => {
                state.isGetDisableTradingLoading = true;
            })
            .addCase(apiGetTtfDisableTrading.fulfilled, (state, action) => {
                state.isGetDisableTradingLoading = false;
                state.disableTrading = action.payload.data;
            })
            .addCase(apiGetTtfDisableTrading.rejected, (state) => {
                state.isGetDisableTradingLoading = false;
            });

        // get ncg data points
        builder
            .addCase(apiGetTtfNcgDataPoints.pending, (state) => {
                state.isGetNcgDataPointsLoading = true;
            })
            .addCase(apiGetTtfNcgDataPoints.fulfilled, (state, action) => {
                state.isGetNcgDataPointsLoading = false;
                state.ncgDataPoints = action.payload.data;
            })
            .addCase(apiGetTtfNcgDataPoints.rejected, (state) => {
                state.isGetNcgDataPointsLoading = false;
            });

        // get analysis signal
        builder
            .addCase(apiGetTtfAnalysisSignal.pending, (state) => {
                state.isGetAnalysisSignalLoading = true;
            })
            .addCase(apiGetTtfAnalysisSignal.fulfilled, (state, action) => {
                state.isGetAnalysisSignalLoading = false;
                state.analysisSignal = action.payload.data;
            })
            .addCase(apiGetTtfAnalysisSignal.rejected, (state) => {
                state.isGetAnalysisSignalLoading = false;
            });
    }
});

export default ttfSlice.reducer;
